import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { redirectIfAuthenticated } from '@/app/guards';
import { LandingPage } from '@/features/auth';

/** Same screen as `/`, reached from a 401 with the page to return to. */
export const Route = createFileRoute('/(public)/login')({
  validateSearch: z.object({
    redirect: z.string().optional(),
    organization: z.string().optional(),
    notice: z.enum(['support_session_ended']).optional().catch(undefined),
  }),
  beforeLoad: redirectIfAuthenticated,
  component: LoginRoute,
});

function LoginRoute() {
  const { redirect, organization, notice } = Route.useSearch();
  return <LandingPage redirectTo={redirect} organizationSlug={organization} notice={notice} />;
}
